import { combineReducers } from "redux";

import { maintenanceDetails } from "./reducer.maintenance"
const maintenanceReducers = combineReducers({
    maintenanceDetails
})
export default maintenanceReducers;
